module.exports = __webpack_public_path__ + "static/media/robot-red-happy-head.b71596b4.svg";